import { observer } from 'mobx-react-lite'
import { useChatbotContext } from 'pages/chatbot/context'
import { ChatbotCollapse } from 'pages/chatbot/ui/ChatbotCollapse'
import { StepObjectiveContent } from './StepObjectiveContent'

export const StepObjective = observer(() => {
  const { errorObjective } = useChatbotContext()

  return (
    <ChatbotCollapse
      icon='target'
      title='Collect data'
      tooltipProps={{
        label: 'Gather specific details like team size, budget, and more',
        placement: 'top',
        breakWord: true,
        maxWidth: 360,
      }}
      error={errorObjective}
    >
      <StepObjectiveContent type={'default'} error={errorObjective} />
    </ChatbotCollapse>
  )
})
